import { createStore } from 'vuex';

export default function createVueStore(store) {
  return createStore({
    ...store,
  });
}
